import React from 'react';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import {
  Button,
  FormattedMessage,
  IconEdit,
  IconSuccess,
  InlineTextButton,
  TypographyWrapper,
} from '..';

import css from './StripeConnectAccountStatusBox.module.css';

const STATUS_VERIFICATION_NEEDED = 'verificationNeeded';
const STATUS_VERIFICATION_SUCCESS = 'verificationSuccess';
const STATUS_VERIFICATION_ERROR = 'verificationError';

const StripeConnectAccountStatusBox = (props) => {
  const { type, onGetStripeConnectAccountLink, inProgress, disabled } = props;

  if (type === STATUS_VERIFICATION_NEEDED) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationNeededBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <TypographyWrapper variant="h2" typographyOverrides={{ style: { fontWeight: 'bold' } }}>
              <FormattedMessage id="StripeConnectAccountStatusBox.verificationNeededTitle" />
            </TypographyWrapper>
          </div>
          <div className={css.verificationBoxText}>
            <TypographyWrapper variant="body1">
              <FormattedMessage id="StripeConnectAccountStatusBox.verificationNeededText" />
            </TypographyWrapper>
          </div>
        </div>

        <Button
          className={css.getVerifiedButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
        >
          <FormattedMessage id="StripeConnectAccountStatusBox.getVerifiedButton" />
        </Button>
      </div>
    );
  }
  if (type === STATUS_VERIFICATION_SUCCESS) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationSuccessBox)}>
        <div
          className={classNames(
            css.verificiationBoxTextWrapper,
            css.verificationBoxSuccessTextWrapper
          )}
        >
          <div className={css.verificationBoxTitle}>
            <Box display="flex" alignItems="center">
              <IconSuccess className={css.icon} />
              <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
                <FormattedMessage id="StripeConnectAccountStatusBox.verificationSuccessTitle" />
              </TypographyWrapper>
            </Box>
          </div>
        </div>

        <InlineTextButton
          className={css.editVerificationButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
        >
          <Box display="flex" alignItems="center">
            <IconEdit className={css.icon} pencilClassName={css.iconEditPencil} />
            <TypographyWrapper variant="body1" typographyOverrides={{ display: 'inline' }}>
              <FormattedMessage id="StripeConnectAccountStatusBox.editAccountButton" />
            </TypographyWrapper>
          </Box>
        </InlineTextButton>
      </div>
    );
  }
  if (type === STATUS_VERIFICATION_ERROR) {
    return (
      <div className={classNames(css.verificiationBox, css.verficiationErrorBox)}>
        <div className={css.verificiationBoxTextWrapper}>
          <div className={css.verificationBoxTitle}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedTitle" />
          </div>
          <div className={css.verificationBoxText}>
            <FormattedMessage id="StripeConnectAccountStatusBox.verificationFailedText" />
          </div>
        </div>

        <Button
          className={css.getVerifiedButton}
          spinnerClassName={css.spinner}
          type="button"
          inProgress={inProgress}
          disabled={disabled}
          onClick={onGetStripeConnectAccountLink}
        >
          <FormattedMessage id="StripeConnectAccountStatusBox.getVerifiedButton" />
        </Button>
      </div>
    );
  }
  throw new Error(`Unknown type ${type} for StripeConnectAccountStatusBox`);
};

export default StripeConnectAccountStatusBox;
